export default "/images/become-host-3.jpeg?647638e521badb34659803d5e9867e41";